import { gsap } from "gsap";
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import moment from "moment";

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export class TotalIrradiancePageHandler extends PageHandler {
	constructor(id) {
		super(id);
		this.fields = {};
		this.latlngChanged = false;
	}

	showError(text) {
		jQuery('.form-status').text(text);
		jQuery('.form-status').addClass('error')
	}

	hideError() {
		jQuery('.form-status').text('');
		jQuery('.form-status').removeClass('error')
	}

	ajax() {

	}

	events() {
		var _this = this;
		/* Tab selection */
		jQuery('body').on('click', '.section__total-irradiance-tab:not(.active):not(.disabled)', function() {
			var view = jQuery(this).data('tab')
			jQuery('.section__total-irradiance-tab.active').removeClass('active')
			jQuery(this).addClass('active')
			_this.changeTab(view);
		})
	}

	transitions() {
		
	}

	doAjaxCheckCity(callback) {
		var _this = this;
		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: {
				'query': _this.fields.cityQuery,
				'action': 'checkcity',
				'_ajax_nonce_checkcity': bipv_script_data.nonce_checkcity
			},
			success: function(response) {
				console.log(response)
				if (response.success)
				{
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});
	}

	doAjaxTotalIrradiance(callback) {
		var _this = this;
		gsap.set('.section__total-irradiance-right .loading-screen', {autoAlpha: 1})
		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: {
				'lat': _this.fields.latitude,
				'lng': _this.fields.longitude,
				'altitude': _this.fields.altitude,
				'tilt': _this.fields.tilt,
				'azimuth': _this.fields.azimuth,
				'dateRangeStart': window.tiMethod == "pvgis" ? _this.fields.dateRangeStart.format('DD/MM/YYYY') : _this.fields.dateRangeStart.format('MM/DD/YYYY'),
				'dateRangeEnd': window.tiMethod == "pvgis" ? _this.fields.dateRangeEnd.format('DD/MM/YYYY') : _this.fields.dateRangeEnd.format('MM/DD/YYYY'),
				'action': 'pvlib',
				'method': window.tiMethod,
				'database': window.selectedDatabase,
				'_ajax_nonce_pvlib': bipv_script_data.nonce_pvlib
			},
			success: function(response) {
				console.log(response)
				if (response.success)
				{
					gsap.set('.section__total-irradiance-right .loading-screen', {autoAlpha: 0})
					jQuery('.return-results textarea').addClass('has-results')
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});
	}

	doAjaxTotalIrradiance_EPW(callback) {
		var _this = this;
		gsap.set('.section__total-irradiance-right .loading-screen', {autoAlpha: 1})
		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: {
				'location': _this.fields.epwLocation,
				'tilt': _this.fields.tilt,
				'azimuth': _this.fields.azimuth,
				'action': 'pvlib_epw',
				'method': window.tiMethod,
				'dateRangeStart': _this.fields.dateRangeStart.format('MM/DD/YYYY'),
				'dateRangeEnd': _this.fields.dateRangeEnd.format('MM/DD/YYYY'),
				'_ajax_nonce_pvlib_epw': bipv_script_data.nonce_pvlib_epw
			},
			success: function(response) {
				if (response.success)
				{
					gsap.set('.section__total-irradiance-right .loading-screen', {autoAlpha: 0})
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});
	}

	formCity() {
		const cache = new Map();
		let debounceTimeout;
		const input = document.getElementById("input-city");
        const suggestions = document.getElementById("suggestions");
        const output = document.getElementById("output");
		var _this = this;

		function displaySuggestions(data) {
			suggestions.innerHTML = "";
			if (data.length > 0) {
				suggestions.style.display = "block";
				data.forEach(location => {
					const div = document.createElement("div");
					div.classList.add("suggestion-item");
					div.textContent = location.city;
					div.addEventListener("click", () => {
						input.value = location.city;
						suggestions.style.display = "none";
						setCoordinates(location);
					});
					suggestions.appendChild(div);
				});
			} else {
				suggestions.style.display = "none";
			}
		}

		function fetchSuggestions() {
			clearTimeout(debounceTimeout);
			debounceTimeout = setTimeout(() => {
				_this.fields.cityQuery = input.value.trim();
				if (!_this.fields.cityQuery) {
					suggestions.style.display = "none";
					return;
				}
				
				if (cache.has(_this.fields.cityQuery)) {
					displaySuggestions(cache.get(_this.fields.cityQuery));
					return;
				}
				_this.doAjaxCheckCity((data) => {
					cache.set(_this.fields.cityQuery, data); // Store results in cache
					displaySuggestions(data);
				});
				
			}, 600);
		}

		function setCoordinates(location) 
		{
            jQuery('#input-latitude').val(location.lat);
            jQuery('#input-longitude').val(location.lng);
			jQuery('.update-map').trigger('click');
        }

        input.addEventListener("input", fetchSuggestions);
        document.addEventListener("click", (e) => {
            if (!input.contains(e.target) && !suggestions.contains(e.target))
                suggestions.style.display = "none";
        });
	}
	
	formLocation() {
        var _this = this;
		if (this.map)
			this.map.remove();

		this.map = L.map('map');
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(this.map);

		this.map.setView([37.9708454, 23.722982], 13);

		const customIcon = L.icon({
            iconUrl: '/wp-content/uploads/2025/02/285659_marker_map_icon-e1740040779222.png',
            iconSize: [48, 48],
            iconAnchor: [24, 24],
            popupAnchor: [1, -34]
        });
        
        var marker = L.marker(this.map.getCenter(), {icon: customIcon, draggable: false}).addTo(this.map);
        
        function updateLatLng() {
            var center = _this.map.getCenter();
            marker.setLatLng(center);
           	jQuery('form.total-irradiance-form input[name="latitude"]').val(center.lat.toFixed(6));
           	jQuery('form.total-irradiance-form input[name="longitude"]').val(center.lng.toFixed(6));

			_this.fields.latitude = center.lat.toFixed(6);
			_this.fields.longitude = center.lng.toFixed(6);
			_this.fields.altitude = 100;
        }
        
        this.map.on('move', updateLatLng);
        updateLatLng();

		jQuery('form.total-irradiance-form input[name="latitude"], form.total-irradiance-form input[name="longitude"]').on('input', function() {
			_this.latlngChanged = true;
		})
		
		jQuery(document).on("keypress", 'form.total-irradiance-form', function (e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				e.preventDefault();
				return false;
			}
		});

		jQuery('form.total-irradiance-form button.update-map').on('click', function() {
			if (_this.latlngChanged)
			{
				jQuery('#input-city').val('');
				_this.latlngChanged = false;
			}
			_this.map.setView([
				parseFloat(jQuery('form.total-irradiance-form input[name="latitude"]').val()), 
				parseFloat(jQuery('form.total-irradiance-form input[name="longitude"]').val())], 
			_this.map.getZoom());
		})
	}

	updateLatLng_EPW(lat, lng, alt) {
		var _this = this;
		_this.map.setView([lat, lng], 13);
		var center = _this.map.getCenter();
		_this.mapMarker.setLatLng(center);
		jQuery('form.total-irradiance-form input[name="latitude"]').val(center.lat.toFixed(6));
		jQuery('form.total-irradiance-form input[name="longitude"]').val(center.lng.toFixed(6));
		jQuery('form.total-irradiance-form input[name="altitude"]').val(alt);

		_this.fields.latitude = center.lat.toFixed(6);
		_this.fields.longitude = center.lng.toFixed(6);
		_this.fields.altitude = alt;
	}
	
	
	formLocation_EPW(lat, lng, alt) {
		var _this = this;
		if (this.map)
			this.map.remove();

		this.map = L.map('map');
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(this.map);

		const customIcon = L.icon({
            iconUrl: '/wp-content/uploads/2025/02/285659_marker_map_icon-e1740040779222.png',
            iconSize: [48, 48],
            iconAnchor: [24, 24],
            popupAnchor: [1, -34]
        });
		this.map.setView([lat, lng], 13);
        this.mapMarker = L.marker(this.map.getCenter(), {icon: customIcon, draggable: false}).addTo(this.map);
        this.updateLatLng_EPW(lat, lng, alt);
		
		jQuery(document).on("keypress", 'form.total-irradiance-form', function (e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				e.preventDefault();
				return false;
			}
		});
	}

	formDateRange() {
		var _this = this;
		jQuery('#graph-daterange').daterangepicker({
			showDropdowns: true,
			autoApply: true,
			locale: { format: "DD/MM/YYYY" },
			startDate: window.tiMethod == "pvgis" ? "01/01/2023" : moment().format('DD/MM/YYYY'),
			minDate: window.tiMethod == "pvgis" ? "01/01/2005" : `01/01/1970`,
			maxDate: window.tiMethod == "pvgis" ? "31/12/2023" : moment().format('DD/MM/YYYY')
		}, function(start, end, label) {
			_this.fields.dateRangeStart = start;
			_this.fields.dateRangeEnd = end;
		});

		_this.fields.dateRangeStart = jQuery('#graph-daterange').data('daterangepicker').startDate;
		_this.fields.dateRangeEnd = jQuery('#graph-daterange').data('daterangepicker').endDate;
	}

	plainEditorAppend(data) {
		var _this = this;

		window.chunkedData = data.split('\n')
		const CHUNK_SIZE = 100; 
		let loadedLines = 0;
		const container = document.querySelector('.return-results');
		const textarea = container.querySelector('textarea');

		jQuery(textarea).off('scroll')

		textarea.value = '';
		textarea.scrollTop = 0;

		function loadChunk() {
			if (loadedLines < chunkedData.length) {
				const nextChunk = chunkedData.slice(loadedLines, loadedLines + CHUNK_SIZE).join('\n');
				textarea.value += (textarea.value ? '\n' : '') + nextChunk;
				loadedLines += CHUNK_SIZE;
			}
		}
	
		loadChunk();
		
		jQuery(textarea).on('scroll', () => {
			const scrollHeight = textarea.scrollHeight;
			const scrollTop = textarea.scrollTop;
			const clientHeight = textarea.clientHeight;

			if (scrollTop + clientHeight >= scrollHeight - 10) {
				loadChunk();
			}
		});
	}

	createTable(data) {
		window.tablerows = data;
		const header = window.tablerows[0];
		const thead = document.createElement("thead"), 
		      theadRow = document.createElement("tr"),
		      tbody = document.createElement("tbody");
		const table = document.getElementById("csv-table");
		const res = document.querySelector('.return-results');
		
		tablerows.slice(1).forEach(element => {
			const opts = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
			element[0] = new Date(element[0]).toLocaleDateString("en-UK", opts);
		})

		header.forEach(element => {
			const th = document.createElement("th");
            th.textContent = element;
            theadRow.appendChild(th);
		});

		thead.appendChild(theadRow);
		// tablerows.slice(1).forEach(row => {
		// 	const tr = document.createElement("tr");
		// 	row.forEach(cell => {
		// 		const td = document.createElement("td");
		// 		td.textContent = cell;
		// 		tr.appendChild(td);
		// 	});
		// 	tbody.appendChild(tr);
		// });

		table.appendChild(thead);
		table.appendChild(tbody);

		/* Chunk loading */
		let loadedLines = 1;
		const CHUNK_SIZE = 20; 
		res.scrollTop = 0;
		jQuery(res).off('scroll')

		function loadChunk() {
			if (loadedLines < window.tablerows.length) {
				const nextChunk = window.tablerows.slice(loadedLines, loadedLines + CHUNK_SIZE);
				nextChunk.forEach(row => {
					const tr = document.createElement("tr");
					row.forEach(cell => {
						const td = document.createElement("td");
						td.textContent = cell;
						tr.appendChild(td);
					});
					tbody.appendChild(tr);
				});
		
				loadedLines += CHUNK_SIZE;
			}
		}
	
		loadChunk();
		
		jQuery(res).on('scroll', () => {
			const scrollHeight = res.scrollHeight;
			const scrollTop = res.scrollTop;
			const clientHeight = res.clientHeight;

			if (scrollTop + clientHeight >= scrollHeight - 100) {
				loadChunk();
			}
		});
	}

	async calcTotalIrradiance() {
		// let restext;
		var _this = this;
		await fetch(`https://api.open-meteo.com/v1/elevation?latitude=${_this.fields.latitude}&longitude=${_this.fields.longitude}`)
			.then(response => response.json())
			.then(data => {
				_this.fields.altitude = data.elevation[0].toFixed(2);
			})
			.catch(error => {
				console.error('Error fetching altitude:', error);
				_this.fields.altitude = 100;
			});
		
		jQuery('form.total-irradiance-form input[name="altitude"]').val(_this.fields.altitude)
		_this.fields.tilt = jQuery('form.total-irradiance-form input[name="tilt"]').val();
		_this.fields.azimuth = jQuery('form.total-irradiance-form input[name="azimuth"]').val();

		// restext = 'PVLIB Parameters:';
		// restext += `\n\tLatitude: ${_this.fields.latitude}`;
		// restext += `\n\tLongitude: ${_this.fields.longitude}`;
		// restext += `\n\tAltitude: ${_this.fields.altitude}`;
		// restext += `\n\tPeriod: ${_this.fields.dateRangeStart.format('DD/MM/YYYY')} - ${_this.fields.dateRangeEnd.format('DD/MM/YYYY')}`;
		// restext += `\n\tTilt angle: ${_this.fields.tilt}`;
		// restext += `\n\tAzimuth: ${_this.fields.azimuth}\n\n`;

		const table = document.getElementById("csv-table");
		table.innerHTML = "";

		gsap.to('.section__total-irradiance-right', {autoAlpha: 1, display: "block"})
		this.doAjaxTotalIrradiance(function(data) {
			// _this.plainEditorAppend(restext + "Results:\n\n" + data);
			_this.createTable(data.trim().split("\n").map(row => row.split(",")));

			if (jQuery('#csv-table').height() > jQuery('.return-results').height())
			{
				gsap.to('.please-scroll', {autoAlpha: 0.9, duration: 0.3});
				window.setTimeout(() => { gsap.to('.please-scroll', {autoAlpha: 0, duration: 0.3}); }, 2000);
			}
		});
	}

	async calcTotalIrradiance_EPW() {
		var _this = this;
	
		_this.fields.tilt = jQuery('form.total-irradiance-form input[name="tilt"]').val();
		_this.fields.azimuth = jQuery('form.total-irradiance-form input[name="azimuth"]').val();
		_this.fields.epwLocation = jQuery('form.total-irradiance-form input[name="location"]').val()

		const table = document.getElementById("csv-table");
		table.innerHTML = "";

		gsap.to('.section__total-irradiance-right', {autoAlpha: 1, display: "block"})
		this.doAjaxTotalIrradiance_EPW(function(data) {
			var coords = data.trim().split("\n")[0]
			const [lat, lng, alt] = coords.split(" ");
			_this.createTable(data.trim().split("\n").slice(1).map(row => row.split(",")));

			if (jQuery('#csv-table').height() > jQuery('.return-results').height())
			{
				gsap.to('.please-scroll', {autoAlpha: 0.9, duration: 0.3});
				window.setTimeout(() => { gsap.to('.please-scroll', {autoAlpha: 0, duration: 0.3}); }, 2000);
			}
		});
	}

	formEvents() {
		var _this = this;
		jQuery('form.total-irradiance-form input[type="submit"]').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			_this.calcTotalIrradiance();
		})
	}

	formEvents_EPW() {
		var _this = this;
		jQuery('form.total-irradiance-form input[type="submit"]').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			_this.calcTotalIrradiance_EPW();
		})
	}

	tiClearsky() {
		this.formCity();
		this.formLocation();
		this.formDateRange();
		this.formEvents();
	}

	tiEPW() {
		var _this = this;
		const locationForm = document.querySelector('.total-irradiance-form');
		const selectedLoc = document.querySelector('main.total-irradiance .section__settings--location .same-as-selected')
		let lat = selectedLoc.getAttribute('data-lat')
		let lng = selectedLoc.getAttribute('data-lng')
		let alt = selectedLoc.getAttribute('data-alt')

		this.formLocation_EPW(lat, lng, alt);
		this.formDateRange();
		this.formEvents_EPW();
		window.selectedLocation = selectedLoc.getAttribute('data-value');
		window.global.initSelect('main.total-irradiance .section__settings--location .custom-select-wrapper', (option) => {
			window.selectedLocation = jQuery(option).data('value');
			let lat = jQuery(option).data('lat')
			let lng = jQuery(option).data('lng')
			let alt = jQuery(option).data('alt')

			locationForm.querySelector('input[name="location"]').value = window.selectedLocation;
			_this.updateLatLng_EPW(lat, lng, alt);
		});
	}

	tiPVGIS() {
		this.formCity();
		this.formLocation();
		this.formDateRange();
		this.formEvents();

		const database = document.querySelector('main.total-irradiance .section__settings--database .same-as-selected')
		window.selectedDatabase = database.getAttribute('data-value');
		window.global.initSelect('main.total-irradiance .section__settings--database .custom-select-wrapper', (option) => {
			window.selectedDatabase = jQuery(option).data('value');
		});
	}

	tiPVGIS_TMY() {
		this.formCity();
		this.formLocation();
		this.formEvents();
	}

	init() {
		this.events();
		var _this = this;
		
		if (window.tiMethod == "epw")
			this.tiEPW();
		else if (window.tiMethod == "pvgis")
			this.tiPVGIS();
		else if (window.tiMethod == "pvgis-tmy")
			this.tiPVGIS_TMY();
		else
			this.tiClearsky();
	}

	destroy() {

	}
}
